import { render, staticRenderFns } from "./Wp_mini_guide_share_page.vue?vue&type=template&id=49174f9e&scoped=true&"
import script from "./Wp_mini_guide_share_page.vue?vue&type=script&lang=js&"
export * from "./Wp_mini_guide_share_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49174f9e",
  null
  
)

export default component.exports